// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { AccordionComponent, ButtonComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { ERROR_ACCORDION_COMPONENT_BUTTON_PROPS } from './constants/error-accordion.constants';
// Event handlers
import { ErrorAccordionHandlers } from './handlers/error-accordion.handlers';
// Styles
import {
  ErrorAccordionComponentStyled,
  ErrorAccordionPreComponentStyled,
} from './error-accordion.component.styled';
// Translations
import { COPY_TEXT, SHOW_DETAILS } from './translations/error-accordion.translations';
// Types
import type { ErrorAccordionComponentType } from './types/error-accordion.type';

const ErrorAccordionComponent = ({
  description,
  error,
}: ErrorAccordionComponentType): React.ReactElement | null => {
  const { handleCopyStackTraceErrorButtonClick } = ErrorAccordionHandlers({ error });

  return (
    <AccordionComponent title={(<FormattedMessage id={SHOW_DETAILS} />) as any}>
      <ErrorAccordionComponentStyled>
        <ErrorAccordionPreComponentStyled>{description}</ErrorAccordionPreComponentStyled>
        <ButtonComponent
          {...ERROR_ACCORDION_COMPONENT_BUTTON_PROPS}
          onClick={handleCopyStackTraceErrorButtonClick}
        >
          <FormattedMessage id={COPY_TEXT} />
        </ButtonComponent>
      </ErrorAccordionComponentStyled>
    </AccordionComponent>
  );
};

export { ErrorAccordionComponent };
